const DB_NAME    = 'shipment_offline_db';
const STORE_NAME = 'pending_uploads';
const DB_VERSION = 1;

let db = null;

const openDB = () => new Promise((resolve, reject) => {
  if (db) return resolve(db);
  const req = indexedDB.open(DB_NAME, DB_VERSION);
  req.onupgradeneeded = (e) => {
    const database = e.target.result;
    if (!database.objectStoreNames.contains(STORE_NAME)) {
      database.createObjectStore(STORE_NAME, { keyPath: 'id' });
    }
  };
  req.onsuccess = (e) => { db = e.target.result; resolve(db); };
  req.onerror   = () => reject(req.error);
});

/**
 * @param {string} id
 * @param {Blob}   blob
 * @param {string} filename
 * @param {string} userId      - Supabase user ID (needed for CSV on retry)
 * @param {string} originalAwb - Raw AWB scanned by user (needed for CSV on retry)
 */
export const savePendingUpload = async (id, blob, filename, userId, originalAwb) => {
  const database = await openDB();
  return new Promise((resolve, reject) => {
    const tx    = database.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    store.put({ id, blob, filename, userId: userId || null, originalAwb: originalAwb || null, savedAt: Date.now() });
    tx.oncomplete = resolve;
    tx.onerror    = () => reject(tx.error);
  });
};

export const getPendingUploads = async () => {
  const database = await openDB();
  return new Promise((resolve, reject) => {
    const tx    = database.transaction(STORE_NAME, 'readonly');
    const store = tx.objectStore(STORE_NAME);
    const req   = store.getAll();
    req.onsuccess = () => resolve(req.result || []);
    req.onerror   = () => reject(req.error);
  });
};

export const removePendingUpload = async (id) => {
  const database = await openDB();
  return new Promise((resolve, reject) => {
    const tx = database.transaction(STORE_NAME, 'readwrite');
    tx.objectStore(STORE_NAME).delete(id);
    tx.oncomplete = resolve;
    tx.onerror    = () => reject(tx.error);
  });
};